import LearningIdentityChartLine from '@/components/charts/learner-identity-chart-line/learner-identity-chart-line';
import LearnerProficiencyChart from '@/components/charts/learner-proficiency-chart/learner-proficiency-chart';
import MilestoneViewComponent from '@/components/showcase/milestone-view/milestone-view';
import ShowcaseEditLayoutComponent from '@/components/showcase/showcase-edit-layout/showcase-edit-layout';
import StudentRoundViewComponent from '@/components/showcase/student-round-view/student-round-view';
import { MarkerListModel } from '@/models/marker/marker-list';
import { markersAPI } from '@/providers/apis/markers/markers';
import { profileAPI } from '@/providers/apis/profile/profile';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import StudentHalfRoundViewComponent from '../student-half-round-view/student-half-round-view';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { isAPICatchError, sortByProperty } from '@/utils/utils';

@Component({
    name: 'student-journey-tree-view',
    components: {
        'student-round-view': StudentHalfRoundViewComponent,
        'milestone-view': MilestoneViewComponent,
        'learner-proficiency-chart-content': LearnerProficiencyChart,
        'showcase-layout': ShowcaseEditLayoutComponent,
        'learner-identity-line': LearningIdentityChartLine,
    },
})
export default class StudentJourneyTreeView extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({default: 'e8a409f5-7fd9-4027-8955-3eda9322413f'})
    public studentId!: string;

    @Prop()
    public isStruggleStudent!: boolean;

    public studentDetails: any = {};

    @Prop()
    public activeMarker!: MarkerListModel;

    public subject: any = {
        code: 'K12.MA',
        title: 'Math',
        framework: 'TMA',
    };


    public learnersData: any = null;

    public generateRouteList: any = [];

    public isEditShowcase: boolean = false;

    public isJourneyLoaded: boolean = true;

    public chartData: any = [];

    public isLoading: boolean = false;

    public providerList: any = [];
    // --------------------------------------------------------------------
    // Actions

    public onClosePullup() {
        this.isEditShowcase = false;
    }

    public onChangeContent(product: any) {
        const marker = this.activeMarker;
        this.generateMakerRoute(marker, product);
    }

    public onViewShowcase() {
        this.isEditShowcase = true;
    }

    public onShowProficiency() {
        this.onViewShowcase();
    }

    public onChartLoaded(chartData: any ) {
        this.chartData = chartData;
    }

    public onChangeLoader(loader: false) {
      this.isJourneyLoaded = false;
    }
    // --------------------------------------------------------------------
    // Hooks

    private created() {
        this.isLoading = true;
        this.fetchUserDetails();
        this.learnersData = this.createSubjectCard(this.subject);
        this.onLoadLearningJourney();
        this.fetchProviderList();
    }

    // --------------------------------------------------------------------
    // Methods

    private fetchUserDetails() {
        profileAPI.fetchUserProfiles(this.studentId).then((userDetails) => {
            this.studentDetails = userDetails[0];
        });
    }

    private createSubjectCard(subject: any) {
        return {
            name: subject.title,
            icon: 'library_books',
            componentData: {
                name: 'learner-proficiency-chart-content',
                propData: {
                    subject: {
                        code: subject.code,
                        id: subject.code,
                        title: subject.title,
                    },
                    userId: this.studentId,
                    month: moment().format('MM'),
                    year: moment().format('YYYY'),
                    subjectCode: subject.code,
                    isCardView: true,
                },
            },
        };
    }

    private onLoadLearningJourney() {
        const params: any = {
            subject: this.subject.code,
            marker: this.activeMarker.id,
            user: this.studentId,
            framework: 'TMA',
        };
        // Temp fix for now
        params.product_id = [446];
        markersAPI.generateMarker(params).then((routeDataList) => {
          markersAPI.fetchRerouteContent(params).then((routeData) => {
              this.generateRouteList = routeData;
              this.isLoading = false;
          });
        });
    }

    private generateMakerRoute(marker: any, product: any = null) {
        const params: any = {
          subject: marker.subject.subjectCode,
          marker: marker.id,
          user: this.studentId,
          framework: 'TMA',
        };

        if (product) {
          params.product_id = [product.productId];
        } else {
          // Temp fix for now
          params.product_id = [446];
        }
        this.isJourneyLoaded = false;
        this.generateRouteList = [];
        markersAPI.generateMarker(params).then(() => {
          if (params.product_id) {
            params.product_id = params.product_id.join(',');
          }
          markersAPI.fetchRerouteContent(params).then((routeData) => {
            this.generateRouteList = routeData;
            this.isJourneyLoaded = true;
           });
        });
      }

      private fetchProviderList() {
          const paggination = {
              offset: 0,
              limit: 50,
              search_terms: '',
          };
          learningRegistryAPI.fetchContentProviderList(paggination).then((data: any) => {
              if (!isAPICatchError(data)) {
                  sortByProperty(data.contentRegistry, 'name', 'ASC');
                  this.providerList = data.contentRegistry;
              }
          });
      }
}
